import "core-js/modules/es6.object.create";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';

var CodeBlock =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CodeBlock, _React$Component);

  function CodeBlock() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CodeBlock.prototype;

  _proto.render = function render() {
    return React.createElement("pre", {
      className: "codeblock tui-language-javascript"
    }, React.createElement("code", {
      dangerouslySetInnerHTML: {
        __html: this.props.code
      }
    }));
  };

  return CodeBlock;
}(React.Component);

export default CodeBlock;